import { Column, ModelBase } from 'loca-boot-core'

export enum FilterState {
  /**
   * 筛选开关打开，在地图上展示该类型的加电资源
   */
  On = 'On',
  /**
   * 筛选开关关闭，在地图上展示该类型的加电资源
   */
  Off = 'Off',
  /**
   * 禁用开关且不在地图上展示该类型的加电资源
   */
  Disabled = 'Disabled',
}

export enum FilterKey {
  /**
   * 资源
   */
  Recharge = 'recharge',
  RechargePS = 'recharge|ps', // 换电
  RechargeCS = 'recharge|cs', // 充电
  /**
   * 服务中心
   */
  ServiceCenter = 'service_center',
  /**
   * 蔚来门店
   */
  NioStore = 'nio_store',
  /**
   * 试驾点
   */
  TestDrive = 'test_drive',

  /**
   * 加电资源类型
   */
  ResourceTypes = 'resource_types',

  /**
   * 加电资源类型
   */
  ThirdStation = 'third_station',
}

export class FilterItem extends ModelBase {
  @Column()
  public key!: string
  @Column()
  public value?: string
  @Column()
  public name!: string
  @Column({ default: FilterState.Off })
  public filterState!: string
  @Column({ childType: FilterItem })
  public options!: FilterItem[]
  @Column()
  public selected?: boolean
}
